import React, {useState} from 'react';
import {useFocusEffect} from '@react-navigation/native';
import {observer} from 'mobx-react';

import Button from '../../components/ui-controls/Button';
import ContentView from '../../components/ui-controls/layout/ContentView';
import config from '../../config';
import {AppRoute} from '../../models/AppRoute';
import {GeocodedSuburb} from '../../models/middleware';
import {RootStoreSelectionNavigatorScreenProps} from '../../models/navigationTypes';
import {useStores} from '../../stores/use-stores';
import {Analytics} from '../../utils/analytics/analytics';
import {EventName, EventScreenName} from '../../utils/analytics/events';
import FeedList from '../articles/components/FeedList';

import SuburbSelectionModal from './SuburbSelectionModal';

const modalBodyText = `All of our stores are independently owned and operated. \
To view accurate pricing, promotions and product availability, \
find your local ${config.APP_NAME} store by entering your suburb or postcode below.`;

export default observer(
  ({
    navigation,
  }: RootStoreSelectionNavigatorScreenProps<AppRoute.MY_STORE_SUBURB_SELECTION>) => {
    const [isSuburbSelectionModalVisible, setIsSuburbSelectionModalVisible] =
      useState(true);
    const {shopSelectionStore} = useStores();

    const selectedStore = shopSelectionStore?.selectedStore;
    const isStoreSelected = selectedStore?.id;

    useFocusEffect(() => setIsSuburbSelectionModalVisible(true));

    const handleSelectSuburb = (suburb: GeocodedSuburb) => {
      shopSelectionStore.resetLoading();
      shopSelectionStore.selectSuburb(suburb);

      Analytics.logEvent({
        eventName: EventName.LocationSelected,
        parameters: {
          screen_name: EventScreenName.SuburbSelection,
          location_id: `${suburb.locality} ${suburb.administrative_area} ${suburb.postal_code}`,
          location_value: `${suburb.locality} ${suburb.administrative_area} ${suburb.postal_code}`,
        },
      });

      navigation.navigate(AppRoute.MY_STORE_STORE_SELECTION);
      setIsSuburbSelectionModalVisible(false);
    };

    const handleBuyAGiftCard = () => {
      setIsSuburbSelectionModalVisible(false);
      navigation.navigate(AppRoute.ROOT_GIFT_CARDS_PROMOTION);
    };
    const extraContent = !!(
      config.FF_IS_GIFT_CARDS_ENABLED && !isStoreSelected
    ) && (
      <Button
        title={'BUY A GIFT CARD'}
        onPress={handleBuyAGiftCard}
        containerStyle={{marginTop: 8}}
      />
    );

    return (
      <ContentView>
        <FeedList isStoreLoading={false} canStoreDeliver canStorePickup />

        <SuburbSelectionModal
          isVisible={isSuburbSelectionModalVisible}
          onSelectSuburb={handleSelectSuburb}
          title="FIND YOUR STORE"
          bodyText={modalBodyText}
          extraContent={extraContent}
        />
      </ContentView>
    );
  },
);
